import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import "./App.css";
import Join from "./pages/Join";
import Sectors from "./pages/Sectors";
import Marine from "./pages/Marine";
import Docking from './pages/Docking';
import Shipbuild from "./pages/Shipbuild";
import Contact from "./pages/Contact";
import About from "./pages/About";
import News from "./pages/News";
import Husbandry from "./pages/Husbandry";
import Spares from "./pages/Spares";
import IndustrialEngineering from "./pages/Industrial";
import Apply from "./pages/Apply";
import SupplierRegistrationForm from "./pages/SupplierRegistrationForm";
import QuotationForm from "./pages/QuotationForm";
import Leadership from "./pages/leadership";
import Faq from "./pages/faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

export default function AppRouter() {
    return (
        <div className="app-wrapper">
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sectors" element={<Sectors/>} />
                    <Route path="/sectors/marine" element={<Marine />} />
                    <Route path="/sectors/docking" element={<Docking />} />
                    <Route path="/sectors/shipbuild" element={<Shipbuild />} />
                    <Route path="/sectors/husbandry" element={<Husbandry />}/>
                    <Route path="/sectors/spares" element={<Spares />} />
                    <Route path="/sectors/industrial" element={<IndustrialEngineering />} />
                    <Route path="/join" element={<Join />} />
                    <Route path="/apply/:id" element={<Apply/>}/>
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/leadership" element={<Leadership />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/srform" element={<SupplierRegistrationForm/>}/>
                    <Route path="/quotation" element={<QuotationForm/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                </Routes>
            </Router>
        </div>
    );
}